import React from 'react';
const AgentDetailsHeader = ({ agtCode }) => (
    <div className="pageHeader">
        <h3>
            Agent Code: {agtCode}
        </h3>
    </div>
);
export default AgentDetailsHeader;